
// import React, { useEffect, useState } from "react";

// const CustomerForm = ({ customer, onSuccess, onCancel }) => {
//   const [formData, setFormData] = useState({
//     type: "king",
//     name: "",
//     co_name: "",
//     mobile1: "",
//     mobile2: "",
//     address: "",
//     investment_amount: "",
//     weekly_interest_amount: "",
//     given_date: new Date().toISOString().split("T")[0],
//     status: "Active",
//   });
//   const [types, setTypes] = useState([]);


//   const [photo, setPhoto] = useState(null);
//   const [customerCode, setCustomerCode] = useState("");
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     if (customer) {
//       setFormData({
//         type: customer.type || "king",
//         name: customer.name || "",
//         co_name: customer.co_name || "",
//         mobile1: customer.mobile1 || "",
//         mobile2: customer.mobile2 || "",
//         address: customer.address || "",
//         investment_amount: customer.investment_amount || "",
//         weekly_interest_amount: customer.weekly_interest_amount || "",
//         given_date: customer.given_date || "",
//         status: customer.status || "Active",
//       });
//       setCustomerCode(customer.customer_code || "");
//     }
//   }, [customer]);


//   useEffect(() => {
//     fetch("http://localhost/erp/customers/types/list.php")
//       .then((res) => res.json())
//       .then((data) => {
//         setTypes(data.types || []);
//       })
//       .catch(() => {
//         setTypes([]);
//       });
//   }, []);


//   useEffect(() => {
//     if (customer) return;
//     fetch(
//       `http://localhost/erp/customers/generate-code.php?type=${formData.type}`,
//     )
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status) setCustomerCode(data.code);
//       });
//   }, [formData.type, customer]);

//   const validate = () => {
//     if (!formData.name.trim()) return "Name is required";
//     if (!formData.co_name.trim()) return "Co Name is required";
//     if (!formData.mobile1.trim()) return "Mobile Number 1 is required";
//     if (!formData.investment_amount) return "Investment Amount is required";
//     if (!formData.weekly_interest_amount)
//       return "Weekly Interest Amount is required";
//     if (!formData.given_date) return "Given Date is required";
//     return null;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const error = validate();
//     if (error) return alert(error);

//     setLoading(true);
//     const form = new FormData();
//     Object.keys(formData).forEach((key) => form.append(key, formData[key]));
//     if (photo) form.append("photo", photo);
//     if (customer?.id) form.append("id", customer.id);

//     const url = customer
//       ? "http://localhost/erp/customers/update.php"
//       : "http://localhost/erp/customers/create.php";

//     try {
//       const res = await fetch(url, { method: "POST", body: form });
//       const data = await res.json();
//       if (data.status) {
//         alert(
//           customer ? "Update Finalized" : "Customer Successfully Registered",
//         );
//         onSuccess();
//       } else {
//         alert(data.message || "Error saving customer");
//       }
//     } catch (err) {
//       alert("Server connection failed");
//     }
//     setLoading(false);
//   };

//   const inputClass =
//     "w-full border border-gray-300 px-4 py-2.5 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-all text-sm";
//   const labelClass =
//     "block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1";

 
//   return (
//     <div className="bg-white shadow-xl rounded-xl border border-gray-100 overflow-hidden">
//       <div className="bg-gray-900 p-6">
//         <h2 className="text-xl font-bold text-white">
//           {customer ? "Modify Customer Record" : "New Customer Registration"}
//         </h2>
//         <p className="text-indigo-300 text-xs font-mono mt-1">
//           Ref ID: {customerCode}
//         </p>
//       </div>

//       <form
//         onSubmit={handleSubmit}
//         className="p-8 grid grid-cols-1 md:grid-cols-2 gap-6"
//       >
//         {/* ROW 1 */}
//         <div>
//           <label className={labelClass}>Customer Type</label>
//           <select
//             value={formData.type}
//             onChange={(e) => setFormData({ ...formData, type: e.target.value })}
//             className={inputClass}
//           >
//             {types.map((t) => (
//               <option key={t.id} value={t.type_name}>
//                 {t.type_name}
//               </option>
//             ))}
//           </select>
//         </div>

//         <div>
//           <label className={labelClass}>Full Name</label>
//           <input
//             type="text"
//             placeholder="John Doe"
//             value={formData.name}
//             className={inputClass}
//             onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//           />
//         </div>

//         {/* ROW 2: Co Name and Origination Date */}
//         <div>
//           <label className={labelClass}>Co Name</label>
//           <input
//             type="text"
//             placeholder="Co name"
//             value={formData.co_name}
//             className={inputClass}
//             onChange={(e) =>
//               setFormData({ ...formData, co_name: e.target.value })
//             }
//           />
//         </div>

//         <div>
//           <label className={labelClass}>Origination Date</label>
//           <input
//             type="date"
//             value={formData.given_date}
//             className={inputClass}
//             onChange={(e) =>
//               setFormData({ ...formData, given_date: e.target.value })
//             }
//           />
//         </div>

//         {/* ROW 3: Mobile Numbers (spanning full width or half each) */}
//         <div className="grid grid-cols-2 gap-2 md:col-span-2">
//           <div>
//             <label className={labelClass}>Primary Mobile</label>
//             <input
//               type="text"
//               value={formData.mobile1}
//               className={inputClass}
//               onChange={(e) =>
//                 setFormData({ ...formData, mobile1: e.target.value })
//               }
//             />
//           </div>
//           <div>
//             <label className={labelClass}>Secondary Mobile</label>
//             <input
//               type="text"
//               value={formData.mobile2}
//               className={inputClass}
//               onChange={(e) =>
//                 setFormData({ ...formData, mobile2: e.target.value })
//               }
//             />
//           </div>
//         </div>

//         {/* ROW 4: Address */}
//         <div className="md:col-span-2">
//           <label className={labelClass}>Residential Address</label>
//           <textarea
//             rows="2"
//             value={formData.address}
//             className={inputClass}
//             onChange={(e) =>
//               setFormData({ ...formData, address: e.target.value })
//             }
//           />
//         </div>

//         {/* ROW 5: Financials */}
//         <div>
//           <label className={labelClass}>Investment Principal (₹)</label>
//           <input
//             type="number"
//             value={formData.investment_amount}
//             className={`${inputClass} font-bold text-green-700`}
//             onChange={(e) =>
//               setFormData({ ...formData, investment_amount: e.target.value })
//             }
//           />
//         </div>

//         <div>
//           <label className={labelClass}>Weekly Interest (₹)</label>
//           <input
//             type="number"
//             value={formData.weekly_interest_amount}
//             className={`${inputClass} font-bold text-indigo-700`}
//             onChange={(e) =>
//               setFormData({
//                 ...formData,
//                 weekly_interest_amount: e.target.value,
//               })
//             }
//           />
//         </div>

//         {/* ROW 6: Status and Photo */}
//         <div>
//           <label className={labelClass}>Account Status</label>
//           <select
//             value={formData.status}
//             className={inputClass}
//             onChange={(e) =>
//               setFormData({ ...formData, status: e.target.value })
//             }
//           >
//             <option value="Active">Active</option>
//             <option value="Close">Closed</option>
//           </select>
//         </div>

//         <div>
//           <label className={labelClass}>Identity Photo</label>
//           <input
//             type="file"
//             className="text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
//             onChange={(e) => setPhoto(e.target.files[0])}
//           />
//         </div>

//         {/* BUTTONS */}
//         <div className="md:col-span-2 flex justify-end gap-3 pt-4 border-t">
//           <button
//             type="button"
//             onClick={onCancel}
//             className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-50"
//           >
//             Cancel
//           </button>
//           <button
//             disabled={loading}
//             className="px-6 py-2.5 rounded-lg bg-indigo-600 text-white font-bold shadow-md hover:bg-indigo-700 disabled:bg-gray-400"
//           >
//             {loading
//               ? "Processing..."
//               : customer
//                 ? "Save Changes"
//                 : "Create Account"}
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };




// export default CustomerForm;



import React, { useEffect, useState } from "react";
import { Api } from "../Api/Api";


const CustomerForm = ({ customer, onSuccess, onCancel }) => {
  // ✅ SAFE current user read
  const currentUser = (() => {
    try {
      return JSON.parse(localStorage.getItem("currentUser"));
    } catch {
      return null;
    }
  })();

  const [formData, setFormData] = useState({
    type: "king",
    name: "",
    co_name: "",
    mobile1: "",
    mobile2: "",
    address: "",
    notes: "",
    investment_amount: "",
    weekly_interest_amount: "",
    given_date: new Date().toISOString().split("T")[0],
    status: "Active",
    investment_type: "normal",
  });

  const [types, setTypes] = useState([]);
  const [photo, setPhoto] = useState(null);
  const [customerCode, setCustomerCode] = useState("");
  const [loading, setLoading] = useState(false);

  // ✅ EDIT MODE – fill form
  useEffect(() => {
    if (customer) {
      setFormData({
        type: customer.type || "king",
        name: customer.name || "",
        co_name: customer.co_name || "",
        mobile1: customer.mobile1 || "",
        mobile2: customer.mobile2 || "",
        address: customer.address || "",
        notes: customer.notes || "",
        investment_amount: customer.investment_amount
          ? parseInt(customer.investment_amount)
          : "",

        weekly_interest_amount: customer.weekly_interest_amount
          ? parseInt(customer.weekly_interest_amount)
          : "",
        given_date: customer.given_date || "",
        status: customer.status || "Active",
        investment_type: customer.investment_type || "normal",
      });
      setCustomerCode(customer.customer_code || "");
    }
  }, [customer]);

  // ✅ Load customer types
  useEffect(() => {
  
    fetch(`${Api}customers/types/list.php`)
      .then((res) => res.json())
      .then((data) => setTypes(data.types || []))
      .catch(() => setTypes([]));
  }, []);

  // ✅ Generate customer code (create only)
  useEffect(() => {
    if (customer) return;

   
    fetch(`${Api}customers/generate-code.php?type=${formData.type}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status) setCustomerCode(data.code);
      });
  }, [formData.type, customer]);

  // ✅ Validation
  const validate = () => {
    if (!formData.name.trim()) return "Name is required";
    if (!formData.co_name.trim()) return "Co Name is required";
    if (!formData.mobile1.trim()) return "Primary mobile is required";
    if (!formData.investment_amount) return "Investment amount required";
    if (!formData.weekly_interest_amount) return "Weekly interest required";
    if (!formData.given_date) return "Given date required";
    return null;
  };

  

  // ✅ SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    const error = validate();
    if (error) return alert(error);

    setLoading(true);

    const form = new FormData();
    Object.keys(formData).forEach((key) => form.append(key, formData[key]));

    // ✅ STORE WHO CREATED / UPDATED
    form.append("created_by", currentUser?.username || "");
    form.append("created_by_id", currentUser?.userId || 0);

    if (photo) form.append("photo", photo);
    if (customer?.id) form.append("id", customer.id);

   
    const url = customer
      ? `${Api}customers/update.php`
      : `${Api}customers/create.php`;


    try {
      const res = await fetch(url, { method: "POST", body: form });
      const data = await res.json();

      if (data.status) {
        alert(customer ? "Customer updated" : "Customer created");
        onSuccess();
      } else {
        alert(data.message || "Save failed");
      }
    } catch {
      alert("Server error");
    }

    setLoading(false);
  };

  const handlePhoneChange = (field, value) => {
  // allow only digits
  const digitsOnly = value.replace(/\D/g, "");

  // limit to 10 digits
  if (digitsOnly.length <= 10) {
    setFormData({ ...formData, [field]: digitsOnly });
  }
};


  const inputClass =
    "w-full border border-gray-300 px-4 py-2.5 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none text-sm";
  const labelClass =
    "block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1";

  return (
    <div className="bg-white shadow-xl rounded-xl border overflow-hidden">
      <div className="bg-gray-900 p-6">
        <h2 className="text-xl font-bold text-white">
          {customer ? "Edit Customer" : "New Customer"}
        </h2>
        <p className="text-indigo-300 text-xs font-mono mt-1">
          Ref ID: {customerCode}
        </p>
      </div>

      <form
        onSubmit={handleSubmit}
        className="p-8 grid grid-cols-1 md:grid-cols-2 gap-6"
      >
        <div>
          <label className={labelClass}>Customer Type</label>
          <select
            value={formData.type}
            onChange={(e) => setFormData({ ...formData, type: e.target.value })}
            className={inputClass}
          >
            {types.map((t) => (
              <option key={t.id} value={t.type_name}>
                {t.type_name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className={labelClass}>Full Name</label>
          <input
            type="text"
            value={formData.name}
            className={inputClass}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
        </div>

        <div>
          <label className={labelClass}>Co Name</label>
          <input
            type="text"
            value={formData.co_name}
            className={inputClass}
            onChange={(e) =>
              setFormData({ ...formData, co_name: e.target.value })
            }
          />
        </div>

        <div>
          <label className={labelClass}>Loan Date</label>
          <input
            type="date"
            value={formData.given_date}
            className={inputClass}
            onChange={(e) =>
              setFormData({ ...formData, given_date: e.target.value })
            }
          />
        </div>

        <div className="md:col-span-2 grid grid-cols-2 gap-2">
          <div>
            <label className={labelClass}>Mobile 1</label>

            <input
              type="tel"
              value={formData.mobile1}
              className={inputClass}
              maxLength={10}
              pattern="[0-9]{10}"
              onChange={(e) => handlePhoneChange("mobile1", e.target.value)}
            />
          </div>
          <div>
            <label className={labelClass}>Mobile 2</label>

            <input
              type="tel"
              value={formData.mobile2}
              className={inputClass}
              maxLength={10}
              pattern="[0-9]{10}"
              onChange={(e) => handlePhoneChange("mobile2", e.target.value)}
            />
          </div>
        </div>

        <div className="md:col-span-2">
          <label className={labelClass}>Address</label>
          <textarea
            rows="2"
            value={formData.address}
            className={inputClass}
            onChange={(e) =>
              setFormData({ ...formData, address: e.target.value })
            }
          />
        </div>

        <div className="md:col-span-2">
          <label className={labelClass}>Notes</label>
          <textarea
            rows="3"
            value={formData.notes}
            className={inputClass}
            placeholder="Additional notes about customer..."
            onChange={(e) =>
              setFormData({ ...formData, notes: e.target.value })
            }
          />
        </div>

        <div className="md:col-span-2">
          <label className="block text-xs font-bold mb-2">
            Investment Type
          </label>

          <div className="flex gap-6">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                value="normal"
                checked={formData.investment_type === "normal"}
                onChange={(e) =>
                  setFormData({ ...formData, investment_type: e.target.value })
                }
              />
              Normal Investment
            </label>

            <label className="flex items-center gap-2">
              <input
                type="radio"
                value="deduct_profit"
                checked={formData.investment_type === "deduct_profit"}
                onChange={(e) =>
                  setFormData({ ...formData, investment_type: e.target.value })
                }
              />
              Deduct From Profit
            </label>
          </div>
        </div>

        <div>
          <label className={labelClass}>Investment (₹)</label>
          <input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            value={formData.investment_amount}
            className={inputClass}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              setFormData({
                ...formData,
                investment_amount: value,
              });
            }}
          />
        </div>

        <div>
          <label className={labelClass}>Weekly Interest (₹)</label>
          <input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            value={formData.weekly_interest_amount}
            className={inputClass}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              setFormData({
                ...formData,
                weekly_interest_amount: value,
              });
            }}
          />
        </div>

        <div>
          <label className={labelClass}>Status</label>
          <select
            value={formData.status}
            className={inputClass}
            onChange={(e) =>
              setFormData({ ...formData, status: e.target.value })
            }
          >
            <option value="Active">Active</option>
            <option value="Close">Closed</option>
          </select>
        </div>

        <div>
          <label className={labelClass}>Photo</label>
          <input type="file" onChange={(e) => setPhoto(e.target.files[0])} />
        </div>

        <div className="md:col-span-2 flex justify-end gap-3 pt-4 border-t">
          <button
            type="button"
            onClick={onCancel}
            className="px-6 py-2 border rounded-lg"
          >
            Cancel
          </button>
          <button
            disabled={loading}
            className="px-6 py-2 bg-indigo-600 text-white rounded-lg font-bold"
          >
            {loading
              ? "Saving..."
              : customer
                ? "Save Changes"
                : "Create Customer"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CustomerForm;
